import React from 'react';
import ImageCloudtalMission from '../../assets/images/eco/our-mission.png';

const IntroSection = ({
                          additionalClassName
}) => {
    return (
        <section className={`w-full py-12 md:py-24 lg:py-32 ${additionalClassName}`}>
            <div className="container px-4 md:px-6">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl text-zinc-100">Wer wir sind</h2>
                    <p className="max-w-[900px] text-zinc-300 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed :text-zinc-400 m-auto">
                        Cloudtal ist ein junges Unternehmen mit dem Ziel, Cloud-Services in Deutschland sicherer, einfacher und nachhaltiger
                        zu machen.
                    </p>
                </div>
                <div className="mx-auto grid max-w-5xl items-center gap-6 py-12 lg:grid-cols-2 lg:gap-12 w-full">
                    {/* Text Content */}
                    <div>
                        <h3 className="text-xl font-semibold mb-4 text-zinc-100">Unsere Mission</h3>
                        <p className="text-zinc-400 mb-4">
                            Wir glauben an eine Zukunft, in der jedes Unternehmen – vom <strong>Einzelgründer</strong> bis zum <strong>Mittelständler</strong> – modernste Technologie nutzen kann, ohne sich um komplexe Server, Wartung oder aufwendige Sicherheitskonzepte kümmern zu müssen.
                        </p>
                        <p className="text-zinc-400">
                            Dabei steht unsere <strong>ökologische Verantwortung</strong> an oberster Stelle: Wir setzen auf <strong>100% Ökostrom</strong> und optimieren unsere Prozesse laufend, um den geringstmöglichen Ressourcenverbrauch zu erzielen.
                        </p>
                    </div>
                    {/* Image */}
                    <div className="flex justify-center">
                        <img
                            src={ImageCloudtalMission}
                            alt="Cloudtal Mission"
                            className="rounded-lg shadow-lg w-full max-w-sm"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default IntroSection;
